// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useParams } from '@tanstack/react-router';

// material ui
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

// feature-components
import ServiceActivationSwitch from '@/features/service-manager/components/ServiceActivationSwitch';

export const Route = createFileRoute(
  '/$accountId/_user/account/services/scheduler',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('service-manager');
  const { accountId } = useParams({
    from: '/$accountId/_user/account/services/scheduler',
  });

  return (
    <Stack spacing={2}>
      <Card>
        <CardHeader
          title={t('services.scheduler.title')}
          action={
            <ServiceActivationSwitch
              managedAccountId={accountId}
              servicePath="scheduler"
              ariaLabel={t('services.scheduler.title')}
            />
          }
          slotProps={{
            title: { variant: 'h6', fontWeight: 600 }
          }}
        />
        <Divider />
        <CardContent>
          <Typography variant="body2" color="text.secondary">
            {t('services.scheduler.description')}
          </Typography>
        </CardContent>
      </Card>
    </Stack>
  );
}

